import { render, staticRenderFns } from "./TagFormDialog.vue?vue&type=template&id=1ebd1c22&scoped=true"
import script from "./TagFormDialog.vue?vue&type=script&lang=js"
export * from "./TagFormDialog.vue?vue&type=script&lang=js"
import style0 from "./TagFormDialog.vue?vue&type=style&index=0&id=1ebd1c22&prod&scoped=true&lang=css"
import style1 from "../../resourceManage/genericResourceManage/genericResourceDialogShell.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_5hxyaa5b57h6kqtn5hqvbk3bcu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebd1c22",
  null
  
)

export default component.exports